'use client';

// Error boundaries must be Client Components
import * as Sentry from '@sentry/nextjs';

import { useEffect } from 'react';

import { Button } from '@/components/ui/button';

function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
	useEffect(() => {
		console.error(error);
		if (process.env.NEXT_PUBLIC_APP_ENV === 'production') {
			Sentry.captureException(error);
		}
	}, [error]);

	return (
		<main className="min-w-screen flex min-h-screen flex-col items-center justify-center px-4 py-8 text-center">
			<h1 className="mb-2 text-xl font-semibold text-gray-900">Something went wrong</h1>
			<p className="text-sm text-gray-600">
				{`We couldn't fetch the data. Please check your connection and try again later.`}
			</p>
			<Button
				onClick={
					// Attempt to recover by trying to re-render the segment
					() => reset()
				}
				className="mt-4"
			>
				Try again
			</Button>
		</main>
	);
}

export default Error;
